module.exports = __webpack_public_path__ + "media/components/src/assets/images/image_text2/14-ac8c25e2b8c8eb2f1bd53922e05daa14.jpg";